import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7 2.487a1.333 1.333 0 0 1 1.967-.094c.24.254.372.591.366.94v2.274a.667.667 0 0 0 1.334 0V3.333A2.667 2.667 0 0 0 6 1.647a.667.667 0 1 0 1 .84m5.48 6.36h.133a.67.67 0 0 0 .667-.54q.072-.484.053-.974a.667.667 0 1 0-1.333 0q0 .37-.073.734a.667.667 0 0 0 .553.78m2 4.04-12-12a.667.667 0 1 0-.947.94l3.8 3.826v1.68a2.667 2.667 0 0 0 4 2.307l.974.973A4 4 0 0 1 4 7.333a.667.667 0 0 0-1.333 0 5.334 5.334 0 0 0 4.666 5.287V14H6a.667.667 0 1 0 0 1.333h4A.667.667 0 1 0 10 14H8.667v-1.38a5.25 5.25 0 0 0 2.566-1.06l2.267 2.267a.667.667 0 0 0 .947-.94zM8 8.667a1.333 1.333 0 0 1-1.333-1.334v-.346L8.3 8.627a1.2 1.2 0 0 1-.3.04"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })